import React, { useEffect, useState } from "react";
import CancelPopUp from "./popups/CancelPopUp";
import apiInstance from "../apiInstance";
import { formatDate } from "../Functions/formatDate";
import UserSubscriptionDetails from "./UserSubscriptionDetails";
import CardPopupWrapper from "./popups/CardPopup";

const Subscription = () => {
    const [isCancel, setIsCancel] = useState(false);
    const [selectedWidgetId, setSelectedWidgetId] = useState(null);
    const [paymentList, setPaymentList] = useState([]);
    const [loading, setLoading] = useState(true);
    const [selectedSubscription, setSelectedSubscription] = useState(null);
    const cardPopupRef = React.useRef(null);

    const fetchPayments = async () => {
        setLoading(true);
        try {
            const response = await apiInstance.get("/subscription");
            if (response) {
                setPaymentList(response?.data?.data);
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchPayments();
    }, []);

    const handleCancelPopUp = (widgetId = null) => {
        setSelectedWidgetId(widgetId);
        setIsCancel(!isCancel);
    };

    const cancelSubscription = async () => {
        if (!selectedWidgetId) return;
        try {
            await apiInstance.delete("/widget/" + selectedWidgetId);
            setIsCancel(false);
            fetchPayments();
        } catch (error) {
            console.log("Error : " + error.message);
        }
    };

    function formatPrice(amount) {
        return `$${amount.toFixed(2)}/month`;
    }

    const handleSubscriptionSelect = (subscription) => {
        setSelectedSubscription(subscription);
    };

    const handleBackToList = () => {
        setSelectedSubscription(null);
    };

    return (
        <>
            <CardPopupWrapper setWidgetList={setPaymentList} ref={cardPopupRef} />

            {selectedSubscription ? (
                <div className="mjwidev-main mjwidev-table">
                    <UserSubscriptionDetails
                        selectedSubscription={selectedSubscription}
                        onBack={handleBackToList}
                    />
                </div>
            ) : (
                // Show subscription list when no subscription is selected
                <div className="mjwi-setting-page mjwi-subscription-page">
                    <h2 className="mjwi-subscription-title">Subscription List</h2>
                    <div className="mjwi-subscription-table-wrapper">
                        {loading ? (
                            // Skeleton Loader
                            <div className="skeleton-loader">
                                <div className="skeleton-row"></div>
                                <div className="skeleton-row"></div>
                                <div className="skeleton-row"></div>
                            </div>
                        ) : !paymentList.length ? (
                            <div className="mjwi-subscription-table-row-center">
                                No Result Found
                            </div>
                        ) : (
                            <table className="mjwi-subscription-table" border="1">
                                <thead>
                                    <tr>
                                        <th>Title</th>
                                        <th>Type</th>
                                        <th>Created</th>
                                        <th>Renewal</th>
                                        <th></th>
                                        <th>Payment Method</th>
                                        <th>Price</th>
                                        <th>Status</th>
                                        <th>Cancel</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {paymentList.map((item, index) => {

                                        // Tool tip info
                                        let editPaymentMethodMsg = "";
                                        let displayEditBtn = true;
                                        switch (item.subStatus) {
                                            case "past_due":
                                            case "active":
                                                displayEditBtn = true;
                                                editPaymentMethodMsg = "";
                                                break;
                                            case "incomplete":
                                                displayEditBtn = false;
                                                editPaymentMethodMsg = "Please complete your payment";
                                                break;
                                            case "canceled":
                                                displayEditBtn = false;
                                                editPaymentMethodMsg = "Your subscription has been canceled";
                                                break;
                                            case "expired":
                                                displayEditBtn = false;
                                                editPaymentMethodMsg = "Your subscription has expired";
                                                break;
                                            case "incomplete_expired":
                                                displayEditBtn = false;
                                                editPaymentMethodMsg = "Your subscription has expired";
                                                break;
                                            case "unpaid":
                                                displayEditBtn = false;
                                                editPaymentMethodMsg = "Please complete your payment.";
                                                break;
                                            default:
                                                displayEditBtn = false;
                                                editPaymentMethodMsg = "Inactive subscription";
                                                break;
                                        }

                                        return (
                                            <tr
                                                key={index}
                                                className="mjwi-subscription-table-row"
                                                onClick={() => handleSubscriptionSelect(item)}
                                                style={{ cursor: "pointer" }}
                                            >
                                                <td>{item.title || "-"}</td>
                                                <td>{item.widgetType.name || "-"}</td>
                                                <td>
                                                    {item.createdAt ? formatDate(item.createdAt) : "-"}
                                                </td>
                                                <td>{item.expires ? formatDate(item.expires) : "-"}</td>
                                                <td>
                                                    <i
                                                        className="fa-solid fa-pen-to-square"
                                                        title={!displayEditBtn ? editPaymentMethodMsg : ''}
                                                        style={{
                                                            // pointerEvents: displayEditBtn ? 'auto' : 'none',
                                                            opacity: displayEditBtn ? 1 : 0.5,
                                                            cursor: displayEditBtn ? 'pointer' : 'not-allowed'
                                                        }}
                                                        onClick={(e) => cardPopupRef?.current?.openCardPopup(e, displayEditBtn, item)}
                                                    />
                                                </td>
                                                <td>{item?.defaultPaymentMethod?.detail || '-'}</td>
                                                <td>{item?.widgetType?.price ? formatPrice(item.widgetType.price) : '-'}</td>
                                                <td>{item?.subStatus || "-"}</td>
                                                <td className="mjwi-subscription-table-button">
                                                    <button
                                                        className="Cancel mjwi-btn"
                                                        onClick={(e) => {
                                                            e.stopPropagation(); // Prevent row click event
                                                            handleCancelPopUp(item._id);
                                                        }}
                                                    >
                                                        <i className="fa-solid fa-trash"></i>
                                                    </button>
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        )}
                    </div>
                </div>
            )}
            {isCancel && (
                <CancelPopUp
                    cancelSubscription={cancelSubscription}
                    handleCancelPopUp={handleCancelPopUp}
                />
            )}
        </>
    );
};

export default Subscription;
